<template>
  <div class="touristGuide">
    <Header></Header>
    <Nav type="3"></Nav>
    <div class="Toptitle">
      <div class="Toptitle_top">
        <h3>{{yidaoname}}旅游指南</h3>
        <!-- <div>
          <span><i class="fa fa-print"></i>打印</span>
          <span><i class="fa fa-share-alt"></i>分享</span>
        </div> -->
      </div>
      <img src="../assets/static/images/footer-split.png" alt="">
    </div>
    <div class="banner">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide v-for="(slide,index) in swiperSlides" :key="index">
          <div class="swiper_img">
            <img :src="slide" alt="">
            <!-- <span></span> -->
            <!-- <p>南粤古驿道活化技术指导组在行动2019（10）</p> -->
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-prev" slot="button-prev">

        </div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>
    <div class="touristGuide_c">
      <div class="touristGuide_traffic">
        <div class="touristGuide_tit">
          <h3><img src="../assets/static/images/touristGuideIcon1.png" />交通</h3>
          <span @click="goTraffic()">更多></span>
        </div>
        <div class="touristGuide_traffic_c">
          <div class="touristGuide_traffic_item">
            <h4 class="touristGuide_traffic_tit"><i></i>高铁</h4>
            <p v-html="sailTraffic[0].content" v-if="sailTraffic.length>0"></p>
          </div>
          <div class="touristGuide_traffic_item">
            <h4 class="touristGuide_traffic_tit"><i></i>动车</h4>
            <p v-html="carTraffic[0].content" v-if="carTraffic.length>0"></p>
          </div>
          <div class="touristGuide_traffic_item">
            <h4 class="touristGuide_traffic_tit"><i></i>公交</h4>
            <p v-html="busTraffic[0].content" v-if="busTraffic.length>0"></p>
          </div>
        </div>
      </div>
      <div class="touristGuide_spot">
        <div class="touristGuide_tit">
          <h3><img src="../assets/static/images/touristGuideIcon2.png" style="width:25px;" />景点</h3>
          <span @click="goTouristGuideMore(1)">更多></span>
        </div>
        <div class="touristGuide_spot_list">
          <div class="touristGuide_spot_item" v-for="(item,index) of interestList" :key="index" @click="goArticleDetail(item.id)">
            <div class="touristGuide_spot_item_img">
              <img :src="item.picture">
            </div>
            <h3>{{item.title}}</h3>
            <p>{{item.subtitle}}</p>
            <!-- <p>樟林古港广场最醒目的当属靠在河口的仿真红头船。红头
              船是樟林古港远洋贸易繁盛时期的象征，当时人们就足乘
              着这一艘艘涂着红漆的船只出洋打工。据说，这艘仿真红
              头船足由当地一位匠人指导建成，他的祖上两代部足以建</p>
            <p>开放时间：全天</p>
            <p>地址：广东省汕头市澄海区东里镇观一村</p> -->
          </div>
        </div>
      </div>
      <div class="touristGuide_food">
        <div class="touristGuide_tit">
          <h3><img src="../assets/static/images/touristGuideIcon3.png" style="width:25px;" />美食</h3>
          <span @click="goTouristGuideMore(2)">更多></span>
        </div>
        <div class="touristGuide_food_list">
          <div class="touristGuide_food_item" v-for="(item,index) of foodList" :key="index" @click="goArticleDetail(item.id)">
            <div class="touristGuide_food_item_img">
              <img :src="item.picture" />
            </div>
            <div class="touristGuide_food_item_text">
              <h3>{{item.title}}</h3>
              <p>{{item.subtitle}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="touristGuide_specialty">
        <div class="touristGuide_tit">
          <h3><img src="../assets/static/images/touristGuideIcon4.png" style="width:25px;" />特产</h3>
          <span @click="goTouristGuideMore(3)">更多></span>
        </div>
        <div class="touristGuide_specialty_list">
          <div class="touristGuide_specialty_item" v-for="(item,index) of nativeList" :key="index" @click="goArticleDetail(item.id)">
            <div class="touristGuide_specialty_item_img">
              <img :src="item.picture" />
            </div>
            <div class="touristGuide_specialty_text">
              <h3>{{item.title}}</h3>
              <p>{{item.subtitle}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<style scoped>
.touristGuide_food_list{justify-content: flex-start;}
.touristGuide_food_item{margin-left: 4.5%;}
.touristGuide_food_item:nth-child(1){margin-left: 0;}
..touristGuide_food_item{width: 30%;}
.touristGuide_food_item_img>img{object-fit: cover;}
</style>
<script>
  import Header from './common/Header.vue'
  import Nav from './common/Nav.vue'
  import Footer from './common/Footer.vue'
  import 'swiper/dist/css/swiper.css'
  import {
    swiper,
    swiperSlide
  } from 'vue-awesome-swiper'
  import {
    request
  } from 'http';
  import Toptitle from './common/Toptitle.vue'
  export default {
    data() {
      return {
        swiperOption: {
          notNextTick: true,
          // autoplay: true,
          pagination: {
            el: '.swiper-pagination'
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        },
        swiperSlides: [],
        targetid: '',
        yidaoname: '',
        foodList: [],
        interestList: [],
        nativeList: [],
        sailTraffic: [],
        carTraffic: [],
        busTraffic: [],
        index:0, 
      }
    },
    components: {
      Header,
      Footer,
      Nav,
      swiper,
      swiperSlide,
      Toptitle
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.swiper
      }
    },
    methods: {
      getAllYiDao() {
        this.axios.post('api/l_yidaoinfo/getAll.do', this.qs(null)).then(res => {
          if (res.status == 200) {
            this.targetid = res.data.data[0].id
            this.yidaoname = res.data.data[0].name
          }
        })
      },
      getFood() {
        this.axios.post('api/index/getArticleList.do', this.qs({
          pageSize: 3,
          pageNo: 1,
          targetid: this.targetid,
          type: 8
        })).then(res => {
          if (res.status == 200) {
            this.foodList = res.data.results
          }
        })
      },
      getInterest() {
        this.axios.post('api/index/getArticleList.do', this.qs({
          pageSize: 6,
          pageNo: 1,
          targetid: this.targetid,
          type: 7
        })).then(res => {
          if (res.status == 200) {
            this.interestList = res.data.results
          }
        })
      },
      getNative() {
        this.axios.post('api/index/getArticleList.do', this.qs({
          pageSize: 6,
          pageNo: 1,
          targetid: this.targetid,
          type: 9
        })).then(res => {
          if (res.status == 200) {
            this.nativeList = res.data.results
          }
        })
      },
      getTraffic() {
        this.axios.post('api/l_yidaotraffic/getListByYiDaoId.do', this.qs({
          yidaoid: this.targetid
        })).then(res => {
          if (res.status == 200) {
            for (let item of res.data.data) {
              if (item.traffictype == 1) {
                this.sailTraffic.push(item)
              } else if (item.traffictype == 2) {
                this.carTraffic.push(item)
              } else if (item.traffictype == 3) {
                this.busTraffic.push(item)
              }
            }
          }
        })
      },
      goTouristGuideMore(type) {
        this.$router.push({
          name: 'touristGuideMore',
          query: {
            targetid: this.targetid,
            type: type
          }
        })
      },
      goArticleDetail(id) {
        this.$router.push({
          name: 'articleDetail',
          query: {
            id: id
          }
        })
      },
      getDetail() {
        this.axios.post('api/l_yidaoinfo/getDetail.do', this.qs({
          id: this.targetid
        })).then(res => {
          if(res.status = 200){
            this.swiperSlides = JSON.parse(res.data.data.picturelist)
            console.log(res)
          }
        })
      },
      goTraffic(){
        this.$router.push({
          name:'traffic',
          query:{
            targetid:this.targetid
          }
        })
        this.resetSetItem('index', this.index)
      }
    },
    mounted() {
      if (this.$route.query.targetid && this.$route.query.name) {
        this.targetid = this.$route.query.targetid
        this.yidaoname = this.$route.query.name
        this.index = this.$route.query.index
        this.getFood()
        this.getInterest()
        this.getNative()
        this.getTraffic()
        this.getDetail()
      } else {
        this.getAllYiDao()
        this.getFood()
        this.getInterest()
        this.getNative()
        this.getTraffic()
        this.getDetail()
      }
    }
  }
</script>

<style>
</style>
